<template>
  <nuttrema-layout-content>
    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :edit.sync="edit"
        :showEdit="!_isEmpty(StuffToEatServingSizes.data)"
        :StuffToEatDetails="StuffToEatDetails">
      </stuff-to-eat-standard-header>
    </template>

    <serving-sizes-list
       slot="central"
      :meta="meta"
      :edit="edit"
      :state="StuffToEatServingSizes">
    </serving-sizes-list>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

import ServingSizesList from './cmpt-serving-sizes-list';

export default {
  name: 'page-stuff-to-eat-serving-sizes',
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    meta: {
      required: false,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatServingSizes() {
      return this.$store.getters.StuffToEatServingSizes(this.id);
    },
  },
  components: {
    ServingSizesList,
    NuttremaGroupAndSort,
    NuttremaLayoutContent,
    StuffToEatInfoSmallCard,
    StuffToEatStandardHeader,
  },
  created() {
    this.$store.dispatch('GetStuffToEatServingSizes', { id: this.id, type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatServingSizes', { id: this.id });
  },
};
</script>

<style lang="scss" scoped>
  .participant-assigned-programs {
    display: flex;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/serving-sizes/page-stuff-to-eat-serving-sizes.vue